import { CountryId } from "../../common/country"
import { ActivityGame, GameProvider } from "./game"


interface Metadata {
  ukLevels: string[];
  nzLevels: string[];
}

interface MygoorooProviderMetadata {

}


export class MygoorooGame extends ActivityGame<Metadata, MygoorooProviderMetadata> {
  constructor(protected data: any) {
    if (data.providerId !== GameProvider.MYGOOROO) {
      throw new Error(`wrong providerId. expected ${GameProvider.MYGOOROO} but got ${data.providerId}`)
    }
    super(data)
  }

  getYearLevels(country: CountryId): string {
    if(country === CountryId.UK)
      return (this.metadata.ukLevels || []).join(', ');
    else if(country === CountryId.NZ)
      return (this.metadata.nzLevels || []).join(', ');
    else
      return (this.metadata.ukLevels || []).join(', ');
  }

}
